import PropTypes from 'prop-types'

import {useSuiContext} from '@s-ui/react-context'
import useMount from '@s-ui/react-hooks/lib/useMount/index.js'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

import DealerRatingsReview from '../../components/dealerRatingsReview/DealerRatingsReview.js'
import {BASE_CLASS as PAGE_BASE_CLASS} from '../../config.js'
import BaseDrawer from '../BaseDrawer/index.js'
import DealerRatingsDisclaimer from './DealerRatingsDisclaimer.js'

const BASE_CLASS = `${PAGE_BASE_CLASS}-dealerRatingsDrawer`

const RATINGS_PAGE_TYPE = 'dealer-ratings-modal'

const DealerRatingsDrawer = ({ad, onClose, pageName, ratings, reviews = []}) => {
  const {domain, i18n} = useSuiContext()
  const {page: analyticsTrackPage} = useAnalyticsTrack()

  useMount(() => {
    if (!ratings) return

    domain
      .get('get_page_tracking_data_use_case')
      .execute({ad, page: pageName, pageType: RATINGS_PAGE_TYPE, ratings})
      .then(analyticsTrackPage)
  })

  return (
    <BaseDrawer onClose={onClose} title={i18n.t('DEALER_RATINGS.TITLE_TAB')}>
      <div className={BASE_CLASS}>
        <DealerRatingsDisclaimer className={`${BASE_CLASS}--Disclaimer`} />

        {reviews.map(review => (
          <DealerRatingsReview key={review.feedbackId} review={review} isBordered showResponse />
        ))}
      </div>
    </BaseDrawer>
  )
}

DealerRatingsDrawer.displayName = 'DealerRatingsDrawer'

DealerRatingsDrawer.propTypes = {
  ad: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  pageName: PropTypes.string,
  ratings: PropTypes.shape({
    average: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    totalReviews: PropTypes.number
  }),
  reviews: PropTypes.arrayOf(PropTypes.object)
}

export default DealerRatingsDrawer
